import { PolicyRef, Policy } from 'pbts/c1/api/policy/v1/policy'
import { AccountProvisionPolicyTestClient, PoliciesClient, PolicySearchClient, PolicyValidateClient } from 'pbts/c1/api/policy/v1/policy.client'
import { createMutationApi } from 'redux_toolkit/lib/createMutationApi'
import { createPagedListApi } from 'redux_toolkit/lib/createPagedListApi'
import { createUnaryApi } from 'redux_toolkit/lib/createUnaryApi'

export const createPolicyApi = createMutationApi(
    PoliciesClient,
    'create',
    (r) => r?.policy as unknown as Policy,
    PolicyRef.typeName,
)

export const searchPoliciesApi = createPagedListApi(
    PolicySearchClient,
    'search',
    undefined,
    PolicyRef.typeName,
)

export const deletePolicyApi = createMutationApi(
    PoliciesClient,
    'delete',
)

export const updatePolicyApi = createMutationApi(
    PoliciesClient,
    'update',
    (r) => r?.policy as unknown as Policy,
    PolicyRef.typeName,
)

export const getPolicyApi = createUnaryApi(
    PoliciesClient,
    'get',
    (r) => r?.policy as unknown as Policy,
    PolicyRef.typeName,
)

export const getPolicyCountUsedByApi = createUnaryApi(
    PolicySearchClient,
    'countUsedBy',
)

export const validatePolicyCel = createUnaryApi(
    PolicyValidateClient,
    'validateCEL',
    undefined,
    PolicyRef.typeName,
)

export const testAccountProvisionPolicy = createUnaryApi(
    AccountProvisionPolicyTestClient,
    'test',
)
